var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('MainHeader'),_c('v-divider'),_c('Info'),_c('v-divider',{staticClass:"mb-4"}),_c('Projects'),_c('v-divider',{staticClass:"mb-4"}),_c('Tools')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }